import React from "react";
import { useSelector } from "react-redux";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload?.length) {
    const { value, payload: barData } = payload[0];
    return (
      <div className="bg-white shadow-md rounded-md p-2 border">
        <div className="flex items-center gap-2">
          <span
            className="inline-block w-3 h-3 rounded-full"
            style={{ backgroundColor: barData.color }}
          ></span>
          <span className="font-medium">{label}</span>
        </div>
        <div className="text-sm text-gray-700">
          KSh {value.toLocaleString()}
        </div>
      </div>
    );
  }
  return null;
};

const TopDisbursements = () => {
  const url = "api/v2/dashboard/fetch-dashboard";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  return (
    <div className="rounded-[.75rem] bg-white p-[1.25rem] w-full">
      <div className="ndovu-gradient-title text-[1rem] font-[400] leading-6 font-lexendS mb-[2.37rem]">
        Top 5 Disbursement per Category
      </div>

      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data?.top5DisbursementPerCategory}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="category" />
           <YAxis  />
          {/* <YAxis tickFormatter={(val) => `KSh ${val / 1000000}M`} /> */}
          <Tooltip content={<CustomTooltip />} />
          <Legend />

          <Bar dataKey="amount" name="Amount (KSh)">
            {data?.top5DisbursementPerCategory?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry?.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TopDisbursements;
